import 'core-js/stable'
import Vue from 'vue'
import CoreuiVuePro from '@coreui/vue-pro'
import App from './App'
import router from './router/index'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from "@/store/store";
import { installManualI18n } from '@/i18n/install'
import OtpInput from "@bachdgvn/vue-otp-input";
import axios from 'axios'
Vue.component("v-otp-input", OtpInput);

// Some legacy screens still use the default axios client instead of the
// shared API service. Keep those requests authenticated as well.
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('accessToken')
  if (token) {
    config.headers = config.headers || {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

installManualI18n()

Vue.use(CoreuiVuePro)

Vue.config.errorHandler = function (err, vm, info) {
  console.error('Vue Error:', err, info);
  alert('Vue Error: ' + err.toString() + '\\nInfo: ' + info);
};

window.addEventListener('unhandledrejection', function(event) {
  console.error('Unhandled promise rejection:', event.reason);
  alert('Promise Error: ' + (event.reason ? event.reason.toString() : 'Unknown'));
});

Vue.prototype.$log = console.log.bind(console)
import moment from 'moment'
Vue.prototype.moment = moment


store.dispatch("user/loadStoredUser").then(() => {
  new Vue({
    el: '#app',
    router,
    store,
    icons,
    template: '<App/>',
    components: {
      App
    }
  }).$mount('#app')
});
